import { Building2, CheckCircle2, ListTodo, Paperclip, Users } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white" data-testid="login-page">
      {/* Left: form */}
      <div className="flex flex-col justify-between p-8 sm:p-12 lg:p-16">
        <div className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-md bg-zinc-900 flex items-center justify-center">
            <Building2 className="h-5 w-5 text-white" />
          </div>
          <span className="font-head font-bold text-lg tracking-tight">PropCollab</span>
        </div>

        <div className="max-w-md">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-400 mb-4">
            Property Maintenance
          </p>
          <h1 className="font-head text-4xl sm:text-5xl font-bold tracking-tight text-zinc-900 leading-[1.05]">
            Fix issues together, faster.
          </h1>
          <p className="mt-5 text-zinc-600 leading-relaxed">
            One shared list for every maintenance task across your properties. Assign work to
            your team, track due dates, and keep photos, documents, spreadsheets and videos in one place.
          </p>

          <Button
            onClick={handleLogin}
            data-testid="google-login-button"
            className="mt-8 h-12 px-6 gap-3 bg-zinc-900 hover:bg-zinc-800 text-white rounded-md w-full sm:w-auto transition-all duration-200"
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24">
              <path fill="#fff" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#fff" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" opacity=".85" />
              <path fill="#fff" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" opacity=".6" />
              <path fill="#fff" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" opacity=".4" />
            </svg>
            Continue with Google
          </Button>

          <div className="mt-10 grid grid-cols-2 gap-4 max-w-sm">
            {[
              { icon: ListTodo, t: "Single to-do list" },
              { icon: Users, t: "Assign your team" },
              { icon: Paperclip, t: "Attach any file" },
              { icon: CheckCircle2, t: "Track to done" },
            ].map((f) => (
              <div key={f.t} className="flex items-center gap-2 text-sm text-zinc-600">
                <f.icon className="h-4 w-4 text-zinc-900" />
                {f.t}
              </div>
            ))}
          </div>
        </div>

        <p className="text-xs text-zinc-400">© {new Date().getFullYear()} PropCollab. Built for property teams.</p>
      </div>

      {/* Right: hero image */}
      <div className="relative hidden lg:block">
        <img
          src="https://images.pexels.com/photos/1313534/pexels-photo-1313534.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Property"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent" />
        <div className="absolute bottom-0 p-12 text-white max-w-md">
          <p className="font-head text-2xl font-semibold leading-snug">
            "Every leak, repair and inspection — organized and never lost."
          </p>
        </div>
      </div>
    </div>
  );
}
